import * as React from 'react';
import Accordion from '../accordion';
import LinkList from '../link-list';
import { cn } from '../../../helpers';

export default function LinkListGroup(props: LinkListGroupProps) {
    const { list, className, useIcons = true, isAccordion, title } = props;

    if (isAccordion) {
        return (
            <article className={cn('link-list-group', className)}>
                <Accordion title={title} borderBottomTitle>
                    <LinkList list={list} useIcons={useIcons} />
                </Accordion>
            </article>
        );
    }

    return (
        <article className={cn('link-list-group', className)}>
            <h5 className="subheading subheading--with-border">{title}</h5>
            <LinkList list={list} useIcons={useIcons} />
        </article>
    );
}
